import {
  getShipmentInfoFromStops,
  stopRenderer,
  warningRenderer,
  getJourneyPallets,
  convertCMtoMeters,
} from '../utils';

const ES_Assignation_template = (journey) => {
  const { stops, extras, item_height, net_full_cost, max_weight, id } = journey;
  const country = 'ES';
  const totalPallets = getJourneyPallets(journey, country);
  const stopsInfo = getShipmentInfoFromStops(stops, country);
  const stopsToRender = stopRenderer(stops, country).join('');
  const warning = warningRenderer(extras, country);
  const totalHeight = convertCMtoMeters(item_height);

  return `
  La carga ${id} es tuya

  ${totalPallets}
  ${totalHeight}m - Altura total
  ${max_weight} Kg - Peso máximo

  ${stopsInfo.shipmentType}
  ${stopsInfo.PICKUP} Recogida(s), ${stopsInfo.DROPOFF} Entrega(s)
  ${stopsToRender}
  ${warning}

  Dinero que cobras: ${net_full_cost} € IVA no incl.
  `;
};

export default ES_Assignation_template;
